import React from 'react';

import styles from './ProgressBarIcon.scss';

const ProgressBarIcon = () => (
  <i className={styles.BarContainer}>
    <div className={styles.Bar} />
  </i>
);

export default ProgressBarIcon;



// WEBPACK FOOTER //
// ./src/components/ProgressBarIcon/ProgressBarIcon.js